module.exports = __webpack_public_path__ + "328e071db26966b264d0d685c4850604.svg";